import icon1 from "./assets/icon1.png";
import info from "./assets/info.png";
import search from "./assets/search.png";
import flag from "./assets/flag.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/api/api";

// Types
interface RegularPhoneNumber {
  full_number: string;
  rate_center: string;
  country_code: string;
  city: string;
  state: string;
}

type TollFreeNumber = string;

const SelectNumber = () => {
  const [regularNumbers, setRegularNumbers] = useState<RegularPhoneNumber[]>(
    []
  );
  const [tollFreeNumbers, setTollFreeNumbers] = useState<TollFreeNumber[]>([]);
  const [selectedType, setSelectedType] = useState<"regular" | "toll_free">(
    "regular"
  );
  const [selectedNumber, setSelectedNumber] = useState<string | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchRegularNumbers = async () => {
      try {
        const response = await authApi.getAvailablePhoneNumbers({
          phoneNumberType: "regular",
          quantity: 40,
        });
        console.log("regular numbers", response.data.phone_numbers);
        setRegularNumbers(response.data.phone_numbers);
      } catch (error) {
        console.error("Error fetching numbers:", error);
      }
    };

    fetchRegularNumbers();
  }, []);

  useEffect(() => {
    const fetchTollFreeNumbers = async () => {
      try {
        const response = await authApi.getAvailablePhoneNumbers({
          phoneNumberType: "toll_free",
          quantity: 40,
        });
        console.log("numbers", response);
        setTollFreeNumbers(response.data.phone_numbers);
      } catch (error) {
        console.error("Error fetching numbers:", error);
      }
    };

    fetchTollFreeNumbers();
  }, []);

  return (
    <div>
      <div className="fixed inset-0 bg-black/20 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl w-full max-w-[800px] p-8 shadow-lg">
          <div className="flex flex-col gap-2 mb-2">
            <div className="w-5 h-5">
              <img src={icon1} alt="icon" />
            </div>
            <h2 className="text-lg font-medium">Select your number</h2>
          </div>

          <p className="text-gray-500 text-sm mb-6">
            Please select your desired number.
          </p>

          <div className="flex mb-6">
            <button
              onClick={() => setSelectedType("regular")}
              className={`flex-1 py-2.5 px-4 text-sm font-medium transition-colors ${
                selectedType === "regular"
                  ? "bg-[#65C466] text-white"
                  : "bg-white text-gray-600 border border-gray-200"
              }`}
            >
              Local DID
            </button>
            <button
              onClick={() => setSelectedType("toll_free")}
              className={`flex-1 py-2.5 px-4 text-sm font-medium transition-colors ${
                selectedType === "toll_free"
                  ? "bg-[#65C466] text-white"
                  : "bg-white text-gray-600 border border-gray-200"
              }`}
            >
              Toll Free
            </button>
          </div>
          {selectedType === "regular" && (
            <div className="flex justify-center items-center border-b border-gray-200 mb-6 w-1/2 mx-auto">
              <img src={search} alt="icon" className="w-4 h-4 ml-2" />
              <input
                type="text"
                placeholder="Search by zip code"
                className="w-full h-11 px-4 pl-10 text-sm focus:outline-none"
              />
            </div>
          )}

          <div className="grid grid-cols-3 gap-4 max-h-[400px] overflow-y-auto">
            {selectedType === "regular"
              ? regularNumbers.map((phone, index) => (
                  <div
                    key={index}
                    onClick={() => setSelectedNumber(phone.full_number)}
                    className={`flex border border-gray-100  rounded-lg hover:border-[#65C466] transition-all cursor-pointer group ${
                      selectedNumber === phone.full_number
                        ? "bg-[#EDF0F7]"
                        : "bg-white"
                    }`}
                  >
                    <div className="w-3 h-full rounded-l-lg">
                      <img
                        src={flag}
                        alt="icon"
                        className="w-4 h-full rounded-l-lg"
                      />
                    </div>
                    <div className="flex flex-col gap-1 p-3 w-full">
                      <p className="text-sm font-medium">{phone.full_number}</p>
                      <p className="text-xs text-gray-500">
                        {phone.city}, {phone.state}
                      </p>
                      <div className="flex justify-between">
                        <p className="text-xs text-gray-500">
                          {phone.rate_center}
                        </p>
                        <img src={info} alt="icon" className="w-4 h-4" />
                      </div>
                    </div>
                  </div>
                ))
              : tollFreeNumbers.map((phone, index) => (
                  <div
                    key={index}
                    onClick={() => setSelectedNumber(phone)}
                    className={`flex border border-gray-100  rounded-lg hover:border-[#65C466] transition-all cursor-pointer group ${
                      selectedNumber === phone ? "bg-[#EDF0F7]" : "bg-white "
                    }`}
                  >
                    <div className="w-3 h-full  rounded-l-lg">
                      <img
                        src={flag}
                        alt="icon"
                        className="w-4 h-full rounded-l-lg"
                      />
                    </div>
                    <div className="flex flex-col gap-1 p-3 w-full">
                      <p className="text-sm font-medium">{phone}</p>

                      <p className="text-xs text-gray-500">Toll Free Number</p>
                      <div className="flex justify-between">
                        <p className="text-xs text-gray-500"></p>
                        <img src={info} alt="icon" className="w-4 h-4" />
                      </div>
                    </div>
                  </div>
                ))}
          </div>

          <div className="mt-6 flex justify-center">
            <button
              onClick={() => {
                navigate("/select_subscription", {
                  state: { selectedNumber, selectedType },
                });
              }}
              className="w-[358px] py-2.5 bg-[#65C466] text-white rounded-lg font-medium text-sm"
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectNumber;
